import { Buffer } from 'buffer';

if (typeof window.global == 'undefined') {
    Object.assign(window, { global: globalThis })
}

if (typeof window.Buffer == 'undefined') {
    Object.assign(window, {Buffer: Buffer})
}


if (typeof window.process == 'undefined') {
    Object.assign(window, {process: { env: {} }})
}

// window.global = window.global ?? window;
// window.Buffer = window.Buffer ?? Buffer;
// window.process = window.process ?? { env: {} }; // Minimal process polyfill

export { };